import type { IconNode } from '../types';

/**
 * @name barbecue
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNNiA0YzAtMSAyLTEgMi0yIiAvPgogIDxwYXRoIGQ9Ik0xMiA0YzAtMSAyLTEgMi0yIiAvPgogIDxwYXRoIGQ9Ik0xOCA0YzAtMSAyLTEgMi0yIiAvPgogIDxwYXRoIGQ9Ik0zIDhhOS4wNiA5IDAgMCAwIDE4IDBaIiAvPgogIDxwYXRoIGQ9Im05LjIgMTUuNi0xLjMgMi42IiAvPgogIDxjaXJjbGUgY3g9IjciIGN5PSIyMCIgcj0iMiIgLz4KICA8cGF0aCBkPSJNOSAyMGg4IiAvPgogIDxwYXRoIGQ9Ik0xNC44IDE1LjYgMTggMjIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/barbecue
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const barbecue: IconNode = [
  ['path', { d: 'M6 4c0-1 2-1 2-2', key: '5f5awp' }],
  ['path', { d: 'M12 4c0-1 2-1 2-2', key: '1rj9qk' }],
  ['path', { d: 'M18 4c0-1 2-1 2-2', key: 'd4wv5y' }],
  ['path', { d: 'M3 8a9.06 9 0 0 0 18 0Z', key: '1j8zev' }],
  ['path', { d: 'm9.2 15.6-1.3 2.6', key: '1f1g6q' }],
  ['circle', { cx: '7', cy: '20', r: '2', key: '1xhi4t' }],
  ['path', { d: 'M9 20h8', key: '1l9aa7' }],
  ['path', { d: 'M14.8 15.6 18 22', key: '1e6dn2' }],
];

export default barbecue;
